module.exports = __webpack_public_path__ + "img/klientix.dce2ee9e.png";